/* eslint-disable no-case-declarations */
import axios, { AxiosError, AxiosResponse } from 'axios'
import * as Redux from 'redux'
import SharedActions from '@SharedActions/loading.action'
import { APIServices } from '@Services/api.service'
import { ToastServices } from '@Services/toast.service'
import { ICommonQuery } from '@Models/common.model'
import { EClassifications } from '@Enum/classifications.enum'
import { MClassification } from '@Models/classification.model'
import * as _ from 'lodash'
import {
    ISafeStorage,
    MSafeStorage,
} from '../../../models/client/safe-storage.model'
import { ClientActionTypes } from '../client.action-types'

const SAFE_STORAGE = `${APIServices.apiUrlV1}/admin/safe-storages`
const CLASSIFICATIONS = `/admin/classifications`

const getSafeStorages = () => {
    return (dispatch: Redux.Dispatch) => {
        APIServices.axiosConfig()
        dispatch(SharedActions.setClientLoading(true) as any)
        const params = {
            status: 'ACTIVE',
            isDetail: true,
        }
        axios
            .get(SAFE_STORAGE, { params })
            .then((response: AxiosResponse) => {
                const payload = response?.data?.data?.map(
                    (item: ISafeStorage) => new MSafeStorage(item)
                )
                const safeModels = response?.data?.data?.map((item: any) => {
                    const models = item?.models?.map(
                        (m: MClassification) => new MClassification(m)
                    )
                    return models
                })
                dispatch({
                    type: ClientActionTypes.GET_SAFE_STORAGE_MODELS,
                    payload: safeModels,
                })
                dispatch(SharedActions.setClientLoading(false) as any)
                dispatch({ type: ClientActionTypes.GET_SAFE_STORAGES, payload })
            })
            .catch((errors: AxiosError) => {
                dispatch(SharedActions.setClientLoading(false) as any)
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const addSafeStorage = (payload: any) => {
    return () => {
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            axios
                .post(SAFE_STORAGE, payload)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Safe Storage created')
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const deleteSafeStorage = (id: string) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        APIServices.axiosConfig()
        const safeStorage = getState()?.client?.safeStorages?.safeStorages
        return new Promise((resolve, reject) => {
            axios
                .delete(`${SAFE_STORAGE}/${id}`)
                .then((response: AxiosResponse) => {
                    const payload = safeStorage?.filter(
                        (item: MSafeStorage) => item?.storageId !== id
                    )
                    dispatch({
                        type: ClientActionTypes.GET_SAFE_STORAGES,
                        payload,
                    })
                    ToastServices.success('Safe Storage deleted')
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const updateSafeStorages = (payload: any) => {
    return () => {
        return new Promise((resolve, reject) => {
            APIServices.axiosConfig()
            axios
                .put(`${SAFE_STORAGE}/bulks`, payload)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Safe Storages updated')
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const setSafeClassifications = (
    params: ICommonQuery,
    data: MClassification[],
    index?: number
) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        if (!params) return

        const { type } = params
        const { safeModels } = getState()?.client?.safeStorages

        const { SAFE_MAKE, SAFE_MODEL } = EClassifications
        const { GET_SAFE_STORAGE_MAKES, GET_SAFE_STORAGE_MODELS } =
            ClientActionTypes

        const payload = data?.length
            ? data?.map((item: MClassification) => new MClassification(item))
            : []

        switch (type) {
            case SAFE_MAKE:
                return dispatch({ type: GET_SAFE_STORAGE_MAKES, payload })
            case SAFE_MODEL:
                if (index === undefined || index === null) return
                const tempSafeModels = _.cloneDeep(safeModels) || []
                tempSafeModels[index] = payload
                return dispatch({
                    type: GET_SAFE_STORAGE_MODELS,
                    payload: tempSafeModels,
                })
            default:
        }
    }
}

const getSafeClassification = (params?: ICommonQuery, index?: number) => {
    return (dispatch: Redux.Dispatch) => {
        axios
            .get(CLASSIFICATIONS, { params: { ...params, limit: 0 } })
            .then((response: AxiosResponse) => {
                const { data } = response?.data
                dispatch(
                    setSafeClassifications(params || {}, data, index) as any
                )
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const ClientSafeStorageActions = {
    getSafeStorages,
    addSafeStorage,
    deleteSafeStorage,
    updateSafeStorages,
    getSafeClassification,
}

export default ClientSafeStorageActions
